import AurigaLoader from '@components/Common/AurigaLoader';

/**
 * ApiLoading Component
 *
 * Displays a centered loading spinner with "APIs initializing..." text.
 * This component is shown during:
 * - Initialization of APIs after successful authentication occurs
 */
const ApiLoading = () => {
  return <AurigaLoader loaderText='APIs initializing...' />;
};

export default ApiLoading;
